import React from 'react';
import classes from './LoginCard.module.css';

const JEM_LOGO_URL =
  "https://imagedelivery.net/THJz7cQLDDpzn89AEYAkbg/dc5010fa-b9ce-4854-e5ed-f7ba2c9ca300/public";

interface LoginCardProps {
  children: React.ReactNode;
  className?: string;
}

interface LoginCardLogoProps {
  className?: string;
}

interface LoginCardTitleProps {
  children: React.ReactNode;
  className?: string;
}

interface LoginCardDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

interface LoginCardPrimaryButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}

const LoginCardRoot: React.FC<LoginCardProps> = ({ children, className }) => (
    <div className={`${classes.loginCard} ${className || ''}`}>
      {children}
    </div>
  );

const LoginCardLogo: React.FC<LoginCardLogoProps> = ({ className }) => (
    <img src={JEM_LOGO_URL} alt="Jem HR Logo" className={classes.logo} />
  );

const LoginCardTitle: React.FC<LoginCardTitleProps> = ({ children, className }) => (
    <h1 className={`${classes.title} ${className || ''}`}>
      {children}
    </h1>
  );

const LoginCardDescription: React.FC<LoginCardDescriptionProps> = ({ children, className }) => (
    <p className={`${classes.description} ${className || ''}`}>
      {children}
    </p>
  );

const LoginCardPrimaryButton: React.FC<LoginCardPrimaryButtonProps> = ({ children, onClick, className }) => (
    <button
      className={`${classes.primaryButton} ${className || ''}`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );

export const LoginCard = Object.assign(LoginCardRoot, {
  Logo: LoginCardLogo,
  Title: LoginCardTitle,
  Description: LoginCardDescription,
  PrimaryButton: LoginCardPrimaryButton,
});